import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Divider, IconButton, ListItemIcon, Menu, MenuItem } from '@mui/material';
import { MapOption } from 'components/request/RequestList';
import { TrackRequest } from 'models/TrackRequest';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next'

export interface TrackRequestActionMenuProps {
  request: TrackRequest;
  onMapButtonClick: (row: any, option: MapOption) => void;
  onDeleteRequest: (request: TrackRequest) => void;
  onRestoreRequest: (request: TrackRequest) => void;
  onOpenDialog?: () => void;
  onCloseDialog?: () => void;
}

export function TrackRequestActionMenu(props: TrackRequestActionMenuProps) {
  const { t } = useTranslation()
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [menuAnchorEl, setMenuAnchorEl] = useState<null | Element>(null);
  const openMenu = Boolean(menuAnchorEl);

  const handleOpenMenu = (ev: React.MouseEvent<Element>) => {
    ev.preventDefault();
    setMenuAnchorEl(ev.currentTarget);
    props.onOpenDialog?.();
  };

  const handleCloseMenu = () => {
    setMenuAnchorEl(null);

    if (!openDeleteDialog) {
      props.onCloseDialog?.();
    }
  };

  const handleDeleteTrack = () => {
    props.onDeleteRequest?.(props.request);
    handleCloseMenu();
  };

  const handleRestoreTrack = () => {
    props.onRestoreRequest?.(props.request);
    handleCloseMenu();
  };

  const handleMapTrack = () => {
    props.onMapButtonClick?.(props.request, MapOption.MAP);
    handleCloseMenu();
  };

  return (
    <>
      <IconButton aria-label="settings" onClick={handleOpenMenu} component="a">
        <MoreVertIcon />
      </IconButton>
      <Menu
        MenuListProps={{
          'aria-labelledby': 'long-button',
        }}
        anchorEl={menuAnchorEl}
        open={openMenu}
        onClose={handleCloseMenu}
      >
        <MenuItem onClick={handleMapTrack}>
          <ListItemIcon>
            <ManageSearchIcon />
          </ListItemIcon>
          {t('assignTrackFromLibrary', 'Assign track from library')}
        </MenuItem>
        <Divider />
        {!props.request.isDeleted && (
          <MenuItem onClick={handleDeleteTrack}>
            <ListItemIcon>
              <DeleteOutlineIcon />
            </ListItemIcon>
            {t('delete', 'Delete')}
          </MenuItem>
        )}
        {props.request.isDeleted && (
          <MenuItem onClick={handleRestoreTrack}>
            <ListItemIcon>
              <DeleteOutlineIcon />
            </ListItemIcon>
            {t('restore', 'Restore')}
          </MenuItem>
        )}
      </Menu>
    </>
  );
}
